import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../../services/central-api/dispatch';
import FilterCheckboxList, { FilterListItem } from './FilterCheckboxList';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
}

function CameraTagsList({ value, setValue }: Props) {
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getCameraTags() {
        try {
            setIsLoading(true);
            const tags = await dispatchService.getDropDownCameraTags();
            setItems(tags.map((tag) => ({ value: tag.id, label: tag.name, color: tag.color })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getCameraTags();
    }, []);

    return <FilterCheckboxList items={items} value={value} setValue={setValue} renderBadge isLoading={isLoading} />;
}

export default CameraTagsList;
